import {
  TrustBadgeBlockTemplateType,
  TrustBadgeVariableItem,
} from "@intelligems/ig-types";

/** How the trust badge settings panel presents a given template. */
export type TrustBadgeTemplateSettings = {
  /** An "image" template is a bare image: no heading, no item typography,
   * color or appearance, and a flattened image-only item editor. */
  kind: "badges" | "image";
  showBody: boolean;
  itemsSectionTitle: string;
  canAddItems: boolean;
  itemNoun: string;
};

const FULL_SETTINGS: TrustBadgeTemplateSettings = {
  kind: "badges",
  showBody: true,
  itemsSectionTitle: "Badges",
  canAddItems: true,
  itemNoun: "badge",
};

// One logo, so there is no grid to lay out and nothing to add.
const BRAND_LOGO_SETTINGS: TrustBadgeTemplateSettings = {
  kind: "image",
  showBody: false,
  itemsSectionTitle: "Image",
  canAddItems: false,
  itemNoun: "image",
};

// Body keeps the rows/columns controls a multi-image block needs.
const IMAGES_SETTINGS: TrustBadgeTemplateSettings = {
  kind: "image",
  showBody: true,
  itemsSectionTitle: "Images",
  canAddItems: true,
  itemNoun: "image",
};

export const getTrustBadgeTemplateSettings = (
  blockTemplate: TrustBadgeBlockTemplateType | null | undefined
): TrustBadgeTemplateSettings => {
  switch (blockTemplate) {
    case "brandLogo":
      return BRAND_LOGO_SETTINGS;
    case "images":
      return IMAGES_SETTINGS;
    default:
      // Null means the template was never recorded, so show every control
      // rather than stripping settings off a block a merchant configured.
      return FULL_SETTINGS;
  }
};

/** The item the add button appends — image templates must not seed an icon. */
export const newTrustBadgeItem = (
  order: number,
  blockTemplate: TrustBadgeBlockTemplateType | null | undefined
): TrustBadgeVariableItem =>
  getTrustBadgeTemplateSettings(blockTemplate).kind === "image"
    ? {
        order,
        title: null,
        subtitle: null,
        type: "image",
        image: null,
        imageSize: 20,
        imageSizeUnit: "percentage",
        mediaSpacing: "base",
        imageAspectRatio: "1:1",
      }
    : {
        order,
        title: "Title example",
        subtitle: "Subtitle example",
        type: "icon",
        icon: "truck",
        iconColor: "info",
        iconSize: "large",
        imageSize: 20,
        imageSizeUnit: "percentage",
        mediaSpacing: "base",
        imageAspectRatio: "1:1",
      };
